
export function toggleOrientationMode(orientation = 'auto') {
    return function (dispatch) {
        dispatch({type: 'SETTINGS_CHANGE_ORIENTATION', payload: {orientation}})
    }
}
export function toggleLayout(layout = 'portrait') {
    return function (dispatch) {
        dispatch({type: 'SETTINGS_CHANGE_LAYOUT', payload: {layout}})
    }
}


// WEBPACK FOOTER //
// ./src/game/config/settings/actions.js